












import { Vue, Component } from "vue-property-decorator";
import { isMobile } from "@/helpers/mediaQueryHelper";
import { customizationStore } from "@/store/typed";

@Component({})
export default class Debug extends Vue {
  get isMobile() {
    return isMobile((this as any).$mq);
  }

  get currentOutputHistoryLength() {
    return (
      customizationStore.currentPrintAreaCustomization.outputHistory.length || 0
    );
  }

  get localStorage() {
    let _lsTotal = 0,
      _xLen,
      _x;
    for (_x in localStorage) {
      // eslint-disable-next-line no-prototype-builtins
      if (!localStorage.hasOwnProperty(_x)) continue;
      _xLen = (localStorage[_x].length + _x.length) * 2;
      _lsTotal += _xLen;
    }
    return (_lsTotal / 1024).toFixed(2);
  }
}
